import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import NoContent, { NO_LEADER } from "NoContent";
import Pagination from "react-js-pagination";
import { confirmAlert } from "react-confirm-alert"; // Import
import { showError, showSuccess } from "ReduxErrorBar";

// constants
import {
  itemCount,
  COMMON_FAIL_MESSAGE,
  screenHeightLeftFromTop,
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
} from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";

// actions
import {
  fetchLeaderboardUserList,
  searchUser,
  resetGamificationPoints,
  addExtraPointsModal,
  fetchLeaderBoardLogall,
} from "LeaderboardActions";
import { fetchUsersCategory } from "DashboardUserAction";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchAllSponsors } from "ActionsSponsors";
import { fetchAllExhibitors } from "ActionsExhibitors";
import { fetchFeature } from "GeneralTabAction";
import { fetchUserInterests } from "ActionsMessage";

// commponents
import ManageUsersGroup from "ManageUsersGroup";
import AddUserDialog from "../../../../users/components/dashboard-add-user";
import LeaderboardUserItem from "./leaderboard-user-item";
import ExtraPointsAddModal from "./extra-points-modal";
//import SponsorInsightMenuIcon from "./sponsorinsight-menu-icon"; leaderboardUserList

class LeaderboardInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.gamification_text_preparing_analytics,
      loader: false,
      pageNumber: 1,
      search: "",
      selectedUsers: [],
      actionOption: false,
      showEmailPreviewModal: false,
      activeLoader: false,
      resetBtnLoader: false,
    };
    this.onSearchUser = this.onSearchUser.bind(this);
  }

  componentDidMount() {
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchAllSponsors(this.props.session);
    this.props.fetchAllExhibitors(this.props.session);
    this.props.fetchFeature(this.props.session);
    this.props.fetchUserInterests(this.props.session);
    this.props.fetchLeaderBoardLogall(this.props.session);
    this.setState({ loading: true });

    // For Single Chaleenges call
    this.props.fetchLeaderboardUserList(
      this.props.session,
      0,
      0,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  componentWillUnmount() {
    // reinitialize states
    this.state = {
      loading: true,
      desc: LocaleStrings.gamification_text_preparing_analytics,
      loader: false,
      pageNumber: 1,
      search: "",
      selectedUsers: [],
      actionOption: false,
      showEmailPreviewModal: false,
      activeLoader: false,
      resetBtnLoader: false,
    };
  }

  // Arrow function for render Sponsors Insights menu divs
  callFunction = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  userAdditionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;
    if (search == "") {
      this.props.fetchLeaderboardUserList(
        this.props.session,
        pageNumber,
        0,
        (response) => {}
      );
    } else if (search != "") {
      this.props.searchUser(
        this.props.session,
        search,
        pageNumber,
        (response) => {}
      );
    }
    this.setState({ ...this.state, pageNumber });
  };

  onSearchUser = (event) => {
    let search = event.target.value;

    let pageNumber = 1;
    if (search == "") {
      this.props.fetchLeaderboardUserList(
        this.props.session,
        pageNumber,
        0,
        (response) => {}
      );
    } else {
      this.props.searchUser(
        this.props.session,
        search,
        pageNumber,
        0,
        (response) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  renderUserList() {
    let pageDataLength = this.props.userList.data.length;

    let { pageNumber } = this.state;

    return _.map(this.props.userList.data, (appUser, index) => {
      return (
        <LeaderboardUserItem
          key={appUser.appuserid}
          appUser={appUser}
          position={index}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          eventDetails={this.props.eventDetails}
        />
      );
    });
  }

  newfc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  /* 
    Requirement - One Reset button is needed in the gamification Leader board screen to clear all the points 
  */

  resetGamificationPoints = () => {
    if (this.props.userList.count > 0) {
      this.setState({ resetBtnLoader: true }); //button state update

      confirmAlert({
        title: LocaleStrings.gamification_leaderboard_table_reset_btn_text,
        message: LocaleStrings.gamification_leaderboard_table_reset_alert_text,
        confirmLabel: LocaleStrings.button_ok,
        cancelLabel: LocaleStrings.button_cancel,
        buttons: [
          {
            label: LocaleStrings.button_ok,
            onClick: () => {
              this.props.resetGamificationPoints(
                this.props.session,
                (callback) => {
                  if (callback.error === 0) {
                    this.props.showSuccess(
                      LocaleStrings.gamification_leaderboard_reset_points__success
                    );

                    this.setState({ pageNumber: 1 });
                    // Call the list again
                    this.props.fetchLeaderboardUserList(
                      this.props.session,
                      0,
                      0,
                      (CallBackResponse) => {}
                    );
                  } else {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  }
                  this.setState({ resetBtnLoader: false });
                }
              );
            },
          },
          {
            label: LocaleStrings.button_cancel,
            onClick: () => {
              this.setState({ resetBtnLoader: false });
            },
          },
        ],
      });
    } else {
      this.props.showError(
        LocaleStrings.gamification_leaderboard_reset_notification_error
      );
    }
  };

  handleAddExtraPoints = () => {
    this.props.addExtraPointsModal({});

    setTimeout(() => {
      this.props.addExtraPointsModal({
        show: true,
        // data: this.props.appUser,
        currentPage: this.state.pageNumber,
      });
    }, 200);
  };

  export = (data) => {
    if (data.length > 0) {
      const groupedData = {};

      data.forEach((item) => {
        const key = item.userid;
        if (!groupedData[key]) {
          groupedData[key] = [];
        }
        groupedData[key].push(item);
      });

      const groupedArray = Object.values(groupedData);

      const result = [].concat(...groupedArray);

      this.setState({ btnXlsx: true });
      let JSONData = {};
      JSONData["logs"] = result;
      this.JSONToCSVConvertor(JSONData);
      this.setState({ btnXlsx: false });
    } else {
      this.props.showError(LocaleStrings.gamification_leaderboard_export_error);
    }
  };

  JSONToCSVConvertor(JSONData) {
    this.setState({ btnXlsx: true });
    var XLSX = require("xlsx");
    let wb = XLSX.utils.book_new();

    let arrjsonn = [];
    _.forEach(JSONData.logs, function (value) {
      let imagePreviewUrl = "";
      if (value && value.award) {
        imagePreviewUrl = `${BASE_IMAGES_URL}/${value.award}?api_key=${ACCESS_FILES_API_KEY}`;
      }
      var obj = {
        Challenge: value?.gamification_challenge_by_challengeid.challengename,
        Name: value.appuser_by_userid?.username,
        Email: value?.appuser_by_userid?.email,
        Type: _.startCase(value?.rewardtype),
        Points: value?.rewardtype == "point" ? value?.points : "-",
        Award: value?.rewardtype == "award" ? imagePreviewUrl : "-",
        Category:
          value?.appuser_by_userid?.usercategory_name &&
          value?.appuser_by_userid?.usercategory_name != ""
            ? value?.appuser_by_userid?.usercategory_name
            : "-",
      };

      arrjsonn.push(obj);
    });

    let JSONDataOBJ = {
      points: arrjsonn,
    };
    _.map(JSONDataOBJ, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);
      // // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });
    XLSX.writeFile(wb, "leaderlog.xlsx");
    this.setState({ btnXlsx: false });
  }

  render() {
    let { deviceSize, gamificationLogList } = this.props;

    return (
      <div
        className={
          this.state.activeLoader ? "user_main_div" : "panel noborder-panel"
        }>
        <div className="content-header-bar">
          {/* Example - 1 - 11 out of 169 users */}
          <div className="vertical-align-center">
            {this.state.pageNumber == 1
              ? 1
              : itemCount * (this.state.pageNumber - 1) + 1}{" "}
            -{" "}
            {this.props.userList.count > itemCount * this.state.pageNumber
              ? itemCount * this.state.pageNumber
              : this.props.userList.count}{" "}
            {LocaleStrings.out + " " + LocaleStrings.of}{" "}
            {this.props.userList.count} {LocaleStrings.users}
          </div>

          <ul className="header-buttons">
            <li>
              <Button
                className="btn-custom-blue schedule-add-button"
                style={{ marginLeft: 0 }}
                bsStyle=""
                onClick={this.handleAddExtraPoints}>
                <img
                  style={{ paddingRight: 10 }}
                  src="../../style/images/header-icons/plus.png"></img>
                {LocaleStrings.gamification_leaderboard_action_addpoint}
              </Button>
            </li>
            {gamificationLogList &&
            gamificationLogList.data &&
            gamificationLogList.data.length > 0 ? (
              <li>
                <Button
                  className="btn-custom-blue schedule-add-button"
                  style={{ marginLeft: 0 }}
                  bsStyle=""
                  loading={this.state.btnXlsx}
                  onClick={() => this.export(gamificationLogList.data)}>
                  {LocaleStrings.button_csv_export}
                </Button>
              </li>
            ) : (
              ""
            )}
            <li key={LocaleStrings.button_search}>
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={this.state.search}
                onChange={this.onSearchUser}
              />
            </li>
            <li>
              <Button
                type="button"
                className="btn btn-custom-white btn"
                title="Press Me"
                onClick={this.resetGamificationPoints}
                disabled={this.state.resetBtnLoader}>
                {this.state.resetBtnLoader ? (
                  <span>
                    <i
                      className="fa fa-spinner icn-spinner"
                      aria-hidden="true"
                      style={{ marginRight: 4 }}></i>{" "}
                    {
                      LocaleStrings.gamification_leaderboard_table_reset_btn_text
                    }
                  </span>
                ) : (
                  <span>
                    <i
                      className="fa fa-refresh"
                      aria-hidden="true"
                      style={{ marginRight: 4 }}></i>{" "}
                    {
                      LocaleStrings.gamification_leaderboard_table_reset_btn_text
                    }
                  </span>
                )}
              </Button>
            </li>
            <li hidden>
              <AddUserDialog
                finishOperationsCallback={this.userAdditionCallback}
              />
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}>
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {this.props.userList.data &&
              this.props.userList.data.length > 0 ? (
                <div className="">
                  <table className="table">
                    <thead>
                      <tr>
                        <th align="center">
                          {
                            LocaleStrings.gamification_leaderboard_table_th_position
                          }
                        </th>
                        <th align="center">
                          {LocaleStrings.gamification_leaderboard_table_th_name}
                        </th>
                        <th align="center">
                          {
                            LocaleStrings.gamification_leaderboard_table_th_points
                          }
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderUserList()}
                    </tbody>
                  </table>
                  <Pagination
                    activePage={this.state.pageNumber}
                    itemsCountPerPage={itemCount}
                    totalItemsCount={this.props.userList.count}
                    pageRangeDisplayed={10}
                    onChange={this.paginationCallback}
                    style={{ float: "right" }}
                  />
                </div>
              ) : (
                <NoContent contentType={NO_LEADER} />
              )}

              {/* ----- Modals ----- */}
              {/* --- User category manage modal --- */}
              {this.props.ShowUserCategoryModal ? (
                <ManageUsersGroup
                  finishOperationsCallback={this.userAdditionCallback}
                />
              ) : null}

              {/* --- Add extra points modal --- */}
              <ExtraPointsAddModal />
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { session, user } = state;

  return {
    session,
    user,
    deviceSize: state.deviceSize,
    userList: state.leaderboardUserList,
    ShowUserCategoryModal: state.ShowDashboardUserCategoryModal,
    gamificationLogList: state.gamificationLogList,
  };
};

// Export with connect
export default connect(mapStateToProps, {
  fetchLeaderboardUserList,
  searchUser,
  fetchUsersCategory,
  fetchUserInterests,
  fetchAllSpeakers,
  fetchAllSponsors,
  fetchAllExhibitors,
  fetchFeature,
  resetGamificationPoints,
  showError,
  showSuccess,
  addExtraPointsModal,
  fetchLeaderBoardLogall,
})(LeaderboardInside);
